export default __webpack_public_path__ + "static/media/GA_ReSynth-2.34ad0b3a.wav";